import style from './style.module.scss'
import editCoachIcon from 'components/Admin/images/edit-coach.svg'
import ImageModal from 'components/Admin/DirectoryPage/ImageModal'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAffiliate } from 'store/selectors'
import { updateCoachImage } from 'store/slices/affiliate'

type Props = {
  id: number
}

export default function CoachAvatar({ id }: Props) {
  const dispatch = useDispatch()
  const affiliateDetail = useSelector(getAffiliate)
  const [imageModalOpen, setImageModalOpen] = useState<boolean>(false)
  const matchingCoach = affiliateDetail?.images?.coaches?.find(
    (coach) => coach.id === id,
  )

  return (
    <>
      <div className={style.imageContainer}>
        <img
          className={style.image}
          src={matchingCoach?.image?.url}
          alt='coach avatar'
        />
        <div className={style.overlay}>
          <img onClick={() => setImageModalOpen(true)} src={editCoachIcon} />
        </div>
      </div>
      {imageModalOpen && (
        <ImageModal
          type='coach'
          affiliateId={affiliateDetail.id}
          userId={id}
          setImageUrl={(newImageUrl) =>
            dispatch(updateCoachImage({ userId: id, imageUrl: newImageUrl }))
          }
          isOpen={imageModalOpen}
          setIsOpen={setImageModalOpen}
        />
      )}
    </>
  )
}
